import * as React from 'react'
import PickingListQuantityInput from './PickingListQuantityInput'
import PickingListCopyQuantityButton from './PickingListCopyQuantityButton'
import AddPickingListLineButton from './AddPickingListLineButton'
import pickingListColorClass from './pickingListColorClass'
import pickingListExportTitle from './pickingListExportTitle'
import { PickingListRowShape, StagedPick } from '../../api/api_data_types'

interface PickingListCardProps {
  row: PickingListRowShape
  currentUser: { username: string }
  changedQuantities: Record<string, StagedPick>
  setChangedQuantities: React.Dispatch<React.SetStateAction<Record<string, StagedPick>>>
  className?: string
}

export default function PickingListCard({ row, currentUser, changedQuantities, setChangedQuantities, className = '' }: PickingListCardProps) {
  const initialItem = row.item?.id != null ? { value: row.item.id, label: row.item.title } : undefined
  const addLineButton = (
    <AddPickingListLineButton
      jobId={row.job_id}
      currentUser={currentUser}
      initialItem={initialItem}
      buttonClass="btn btn-outline-primary btn-sm"
    />
  )

  if (row.row_type === 'record') {
    return (
      <div
        className={`card ${row.nested ? 'picking-list-record-row' : ''} ${row.export_status !== 'exported' ? 'picking-list-export-pending' : ''} ${className}`}
        title={pickingListExportTitle(row)}
      >
        <div className="card-header">
          <h5 className="card-title mb-0">{row.item && row.item.no}</h5>
        </div>
        <div className="card-body">
          <h5 className="card-title mb-3">{row.item && row.item.description}</h5>
          <div>
            <strong>Placering Øst:</strong>
            <span className="text-muted ml-2">{row.item && row.item.shelf_no_east}</span>
          </div>
          <div>
            <strong>Placering Vest:</strong>
            <span className="text-muted ml-2">{row.item && row.item.shelf_no_dgj}</span>
          </div>
          <div>
            <strong>Lokation:</strong>
            <span className="text-muted ml-2">{row.location_code}</span>
          </div>
          <div>
            <strong>Efterkalk. antal:</strong>
            <span className="text-muted ml-2">{Number(row.quantity).toLocaleString('da-DK')}</span>
          </div>

          {!row.nested && <div className="mt-3">{addLineButton}</div>}
        </div>
      </div>
    )
  }

  const estimatedQuantity = Number(row.estimated_quantity)
  const jobCostQuantity = Number(row.job_cost_quantity)

  return (
    <div className={`card ${className}`}>
      <div className="card-header">
        <h5 className="card-title mb-0">{row.item && row.item.no}</h5>
      </div>
      <div className="card-body">
        <h5 className="card-title mb-3">{row.item && row.item.description}</h5>
        <div>
          <strong>Placering Øst:</strong>
          <span className="text-muted ml-2">{row.item && row.item.shelf_no_east}</span>
        </div>
        <div>
          <strong>Placering Vest:</strong>
          <span className="text-muted ml-2">{row.item && row.item.shelf_no_dgj}</span>
        </div>
        <div>
          <strong>Lokation:</strong>
          <span className="text-muted ml-2">{row.location_code}</span>
        </div>
        <div>
          <strong>Efterkalk. antal:</strong>
          <span className={`${pickingListColorClass(row)} ml-2`}>{jobCostQuantity.toLocaleString('da-DK')}</span>
        </div>

        <table className="table mt-3">
          <thead>
            <tr>
              <th>Antal</th>
              <th></th>
              <th>Forkalk. antal</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="align-middle">
                <PickingListQuantityInput row={row} changedQuantities={changedQuantities} setChangedQuantities={setChangedQuantities} />
              </td>
              <td className="align-middle">
                <PickingListCopyQuantityButton
                  row={row}
                  changedQuantities={changedQuantities}
                  setChangedQuantities={setChangedQuantities}
                />
              </td>
              <td className="align-middle">{estimatedQuantity.toLocaleString('da-DK')}</td>
            </tr>
          </tbody>
        </table>

        {addLineButton}
      </div>
    </div>
  )
}
